import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bom-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  now: Date;

  constructor() {}

  ngOnInit() {
    this.now = new Date();
  }
}
